import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import AltTextInput from '../../../shared/AltTextInput/index.jsx';
import RadioButton from '../../../shared/RadioButton/index.jsx';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;
  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const RadioContainer = styled.div`
  border: 1px solid #6d6d6d;
  margin-bottom: 1rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const RadioContainerWithInfo = styled.div`
  border: 1px solid #6d6d6d;
  margin-bottom: 0.5rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const InfoText = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #333;
  padding-bottom: 1rem;
  margin-bottom: 0;
`;

const StyledSpan = styled.span`
  color: #6d6d6d;
  margin-left: 1.5rem;
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const HomeownerStep12 = ({ incrementStep, decrementStep, formData }) => {
  const validatePhone =
    formData.homeownerPhone && formData.homeownerPhone.length === 12;
  const initValidated =
    formData.preferredContactMethod === 'phone'
      ? validatePhone
      : formData.preferredContactMethod;

  const validated =
    formData.registrantType != 'homeowner'
      ? initValidated
      : formData.preferredContactMethod && validatePhone && formData.email;

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 13 - how would you like to be contacted"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>
          Can you describe the type of shingles you had installed?
        </BackText>
      </BackWrapper>
      <IntroMessage>
        Nice to meet you {formData.propertyOwnerFName}. In case of future
        communication,
      </IntroMessage>
      <Header>How would you like to be contacted?</Header>
      <RadioContainerWithInfo>
        <RadioButton
          value="email"
          fieldKey="preferredContactMethod"
          htmlAttributes={{}}
        >
          <div>
            <label>Email</label>
            <StyledSpan>{formData.email}</StyledSpan>
          </div>
        </RadioButton>
      </RadioContainerWithInfo>
      <InfoText>
        For the warranty registration, you will be emailed regardless of your
        communication selection.
      </InfoText>
      <RadioContainer>
        <RadioButton
          value="phone"
          fieldKey="preferredContactMethod"
          htmlAttributes={{}}
        >
          <FlexRow>
            <label>Phone</label>
            <FlexRow>
              <span>&nbsp;&nbsp;|&nbsp;</span>
              <AltTextInput
                fieldKey="homeownerPhone"
                value={formData.homeownerPhone || ''}
                htmlAttributes={{
                  placeholder: 'Enter phone number here',
                  pattern: '[0-9 -]*',
                  isphoneinput: 'true',
                  maxLength: 12,
                }}
              />
            </FlexRow>
          </FlexRow>
        </RadioButton>
      </RadioContainer>
      <RadioContainer>
        <RadioButton
          value="mail"
          fieldKey="preferredContactMethod"
          htmlAttributes={{}}
        >
          <div>
            <label>Mail</label>
            <StyledSpan>{formData.ownerAddress.street}</StyledSpan>
          </div>
        </RadioButton>
      </RadioContainer>
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 13 - how would you like to be contacted"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep12);
